/* global madCustomerCardShipping */

import domReady from '@wordpress/dom-ready';
import { setInputFields } from '../../utils/customer-card-utility';
domReady( async () => {
	const customerCardShipping = document.querySelector( 'form.checkout #adresskort' );
	const onShippingCardChange = () => {
		const userId = +customerCardShipping.value;

		if ( ! madCustomerCardShipping ) {
			return;
		}

		setInputFields( madCustomerCardShipping[ userId ], customerCardShipping.closest( 'form' ) );
	};

	if ( ! customerCardShipping ) {
		return;
	}

	// eslint-disable-next-line no-console
	customerCardShipping.addEventListener( 'change', onShippingCardChange );
} );
